import { BASE_PATH, PUBLICA_URL } from '../constants';
import { history } from 'routes/history';

const Api = require('../services/api');
const apiURLBuilder = require('../core/apiURLBuilder');
const Storage = require('utilities/storage');
const formActions = require('react-redux-form').actions;
const { getReferenceCodeByCountry } = require('utilities/multiLanguageHelper');
import {
    FIOC,
    IDENTIFICATION,
    STANDBY_LOAN,
    TRANSFER_OTP,
    PENDING_OTP,
    RESULT_LOAN_COUNTEROFFER,
    RESULT_LOAN_APPROVED,
    DOCUMENTATION,
    CONTRACTING_LOAN,
    INE_LOAN,
    SUCCESS_LOAN,
    SIGNATURE_KEY,
} from '../ares/commons/constants/steps';
import { SUCCESS_STATUS_CODE } from 'constants/requests';
import { PAYDAY_PARTICULAR_DAY } from '../ares/Contracting/utils';
import preLoaderActions from 'actions/preLoaderActions';

const getDossier = function (formActions, callback, dossierId, accessToken) {
    return Api.get(apiURLBuilder.getURL('getDossier', { dossierId }), {
        header: {
            accessToken,
        },
    })
        .then(response => {
            const { id, documentType, documentNumber, birthDate } = response.body;
            formActions.change('userProfile.dossierId', id);
            formActions.change('userProfile.documentType', documentType);
            formActions.change('userProfile.documentNumber', documentNumber);
            formActions.change('userProfile.birthDate', birthDate);
            formActions.change('userProfile.isAres', true);

            return response;
        })
        .catch(error => {
            callback(error);
        });
};

const loanStatus = accessToken => async (dispatch, getState) => {
    dispatch(formActions.change('userProfile.chargingLoan', true));
    dispatch(formActions.change('userProfile.isAres', true));
    const accessTokenStore = getState().userProfile.accessToken;
    const authorizationString = `Bearer ${accessToken || accessTokenStore}`;
    const header = {
        authorization: authorizationString,
    };
    const {
        body: { status, data },
    } = await Api.get(apiURLBuilder.getURL('loanStatus'), {
        header,
    });

    dispatch(formActions.change('userProfile.status', status));

    const saveLoanTableData = loanData => {
        dispatch(formActions.change('userProfile.amount', loanData.amount));
        dispatch(formActions.change('userProfile.term', loanData.term));
        dispatch(formActions.change('userProfile.tin', loanData.tin));
        dispatch(formActions.change('userProfile.tae', loanData.tae));
        dispatch(formActions.change('userProfile.openingFee', loanData.openingFee));
        dispatch(formActions.change('userProfile.totalAmount', loanData.totalAmount));
        dispatch(formActions.change('userProfile.monthlyFee', loanData.monthlyFee));
        dispatch(formActions.change('userProfile.totalCost', loanData.totalCost));
    };

    if (status === FIOC) {
        dispatch(formActions.change('userProfile.name', data.name));
        dispatch(formActions.change('userProfile.accountType', data.employmentStatus));
    } else if (status === IDENTIFICATION) {
        dispatch(formActions.change('userProfile.name', data.name));
        dispatch(formActions.change('userProfile.lastName', data.firstName));
        dispatch(formActions.change('userProfile.secondLastName', data.lastName));
        dispatch(formActions.change('userProfile.identityIban', data.identificationIban));
        dispatch(formActions.change('userProfile.documentType', data.documentType));
        dispatch(formActions.change('userProfile.docNumber', data.documentNumber));
    } else if (status === TRANSFER_OTP || status === PENDING_OTP) {
        dispatch(formActions.change('userProfile.name', data.name));
    } else if (status === STANDBY_LOAN) {
        saveLoanTableData(data);
        dispatch(formActions.change('userProfile.name', data.name));
        dispatch(formActions.change('userProfile.frequency', data.frequency));
        dispatch(formActions.change('userProfile.loanApproved', data.loanApproved));
        dispatch(formActions.change('userProfile.loanCounteroffer', data.loanCounteroffer));
        dispatch(formActions.change('userProfile.documentationStatusCounter', data.documentationStatusCounter));
    } else if (status === RESULT_LOAN_COUNTEROFFER || status === RESULT_LOAN_APPROVED) {
        saveLoanTableData(data);
    } else if (status === DOCUMENTATION) {
        dispatch(formActions.change('userProfile.acceptedVedacon', data.acceptedVedacon));
        dispatch(formActions.change('userProfile.documentationStatusCounter', data.documentationStatusCounter));
    } else if (status === CONTRACTING_LOAN) {
        const contractingData = data.contractingData;

        dispatch(formActions.change('userProfile.accounts', data.accounts));
        dispatch(formActions.change('userProfile.contractingData', contractingData));
        dispatch(formActions.change('userProfile.paymentDayType', contractingData.paymentDayType));
        dispatch(formActions.change('userProfile.paymentDay', contractingData.paymentDay));
        dispatch(formActions.change('userProfile.paymentDayType', PAYDAY_PARTICULAR_DAY));

        saveLoanTableData(contractingData);
    } else if (status === INE_LOAN) {
        dispatch(formActions.change('userProfile.hiringPdf', `data:application/pdf;base64,${data.hiring}`));
    } else if (status === SUCCESS_LOAN) {
        dispatch(formActions.change('userProfile.name', data.name));
    } else if (status === SIGNATURE_KEY) {
        dispatch(formActions.change('userProfile.birthDate', data.birthDate));
    }

    dispatch(formActions.change('userProfile.dossierId', ''));
    dispatch(formActions.change('userProfile.chargingLoan', false));

    return { status, data };
};

const loanRegister = (payload, dispatch) => {
    return Api.post(apiURLBuilder.getURL('loanRegister'), {
        query: payload,
        header: {},
    })
        .then(({ body }) => {
            const expires = new Date(new Date().getTime() + 45 * 60 * 1000);
            Storage.cookies.set('accessToken', body.accessToken, { expires });
            Storage.cookies.set('refreshToken', body.refreshToken, { expires });
            dispatch(formActions.change('userProfile.accessToken', body.accessToken));
            dispatch(formActions.change('userProfile.refreshToken', body.refreshToken));
            dispatch(loanStatus());

            return body;
        })
        .catch(() => {
            dispatch(formActions.change('userProfile.errorContent', 'messagesScreen-defaultErrorContent_ares'));
            history.push(`${BASE_PATH}/errors`);
        });
};

const loanIdentification = callback => async () => {
    const header = {
        authorization: `Bearer ${Storage.cookies.get('accessToken')}`,
        originCountry: getReferenceCodeByCountry().toUpperCase(),
    };

    return Api.post(apiURLBuilder.getURL('loanIdentification'), {
        header,
    })
        .then(callback)
        .catch(() => {
            history.push(`${BASE_PATH}/errors`);
        });
};

const changeStandbyLoanStatus = async (payload, dispatch) => {
    let changingStatus = false;
    const header = {
        authorization: `Bearer ${Storage.cookies.get('accessToken')}`,
    };

    try {
        const { status } = await Api.post(apiURLBuilder.getURL('loanStatus'), {
            header,
            query: payload,
        });

        if (status === SUCCESS_STATUS_CODE) {
            changingStatus = true;
            dispatch(loanStatus());
        }
    } catch (error) {
        history.push(`${BASE_PATH}/errors`);
    }

    return { changingStatus };
};

const loanCancel = async () =>
    Api.post(apiURLBuilder.getURL('loanCancel'), {
        header: {
            authorization: `Bearer ${Storage.cookies.get('accessToken')}`,
        },
    })
        .then(() => {
            window.location.href = PUBLICA_URL;
        })
        .catch(() => {
            window.location.href = PUBLICA_URL;
        });

const loanHiring = async dispatch =>
    Api.post(apiURLBuilder.getURL('loanHiring'), {
        header: {
            authorization: `Bearer ${Storage.cookies.get('accessToken')}`,
        },
    })
        .then(() => {
            dispatch(loanStatus());
        })
        .catch(() => {
            history.push(`${BASE_PATH}/errors`);
        });

const loanContracting = async (payload, dispatch) => {
    dispatch(preLoaderActions.showPreLoader());
    const header = {
        authorization: `Bearer ${Storage.cookies.get('accessToken')}`,
    };

    return Api.post(apiURLBuilder.getURL('loanContract'), {
        header,
        query: payload,
    })
        .then(() => {
            dispatch(loanStatus());
        })
        .catch(() => {
            history.push(`${BASE_PATH}/errors`);
        });
};

const loanIne = async dispatch =>
    Api.post(apiURLBuilder.getURL('loanIne'), {
        header: {
            authorization: `Bearer ${Storage.cookies.get('accessToken')}`,
        },
    })
        .then(() => {
            dispatch(loanStatus());
        })
        .catch(() => {
            history.push(`${BASE_PATH}/errors`);
        });

export default {
    getDossier,
    loanRegister,
    loanStatus,
    loanIdentification,
    changeStandbyLoanStatus,
    loanCancel,
    loanHiring,
    loanContracting,
    loanIne,
};
